import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'yi-dialog',
  template: require('./dialog.component.html'),
  styles: [require('./dialog.component.scss')],
  animations: [
    trigger('dialog', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('200ms', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('200ms', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class DialogComponent implements OnInit {
  @Input() component: Component;
  @Input() visible: boolean;
  @Output() closeDialog: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() moveToNextDialog: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {
  }

  ngOnInit() {
  }

  close() {
    this.visible = false;
    this.closeDialog.emit(this.visible);
  }

  nextDialog(nextComponent) {
    this.moveToNextDialog.emit(nextComponent);
  }
}
